import { ErrorState } from '../types';
import { DasEndpointType, LocatorType } from '../types/Device';

const FORMAT_ERROR: ErrorState = {
  isError: true,
  message: 'Das ID must be 7 letters followed by 6 digits.',
};

const isValidFormat = (value: string) => /^[A-Z]{7}\d{6}$/.test(value);

type PatternEntry = { pattern: RegExp; name: string };

const DASLOOP_ENTRY: PatternEntry = {
  pattern: /(L|I)(N|L|W|F|M|H)(B|G|V|S|X)(C|E|J|M)[A-Z]{3}\d{6}/,
  name: 'DasLoop',
};

export const DAS_ID_PATTERNS: Partial<Record<DasEndpointType, PatternEntry>> = {
  dasloop: DASLOOP_ENTRY,
  dasloop_video: DASLOOP_ENTRY,
  dastrack: { pattern: /P(N|L|W|F|M)BA[A-Z]{3}\d{6}/, name: 'DasTrack' },
  dastrack_v: { pattern: /V(N|L|W|F|M)BA[A-Z]{3}\d{6}/, name: 'DasTrack-V' },
  dastemp: { pattern: /E(B|L|G|N)TA[A-Z]{3}\d{6}/, name: 'DasTemp' },
  daspower: { pattern: /E(B|L|G|N)PA[A-Z]{3}\d{6}/, name: 'DasPower' },
  dasair: { pattern: /A(L|B)A[A-F][A-Z]{3}\d{6}/, name: 'DasAir' },
  das_aoa_tag: { pattern: /T(B|U)(A|P)A[A-Z]{3}\d{6}/, name: 'DasAoaTag' },
  daswater: { pattern: /WLLA[A-Z]{3}\d{6}/, name: 'DasWater-L' },
  daswatch: { pattern: /^W[A-Z]A[A-Z]{4}\d{6}$/, name: 'DasWatch' },
  dasgas: { pattern: /A(B|L)G[A-F][A-Z]{3}\d{6}/, name: 'DasGas' },
  daslock: { pattern: /E(B|L|G|N)L(L|S)[A-Z]{3}\d{6}/, name: 'DasLock' },
  dascas: { pattern: /PNBC[A-Z]{3}\d{6}/, name: 'DasCAS' },
  dascas_g: { pattern: /P(N|L|W|F|M)BG[A-Z]{3}\d{6}/, name: 'Main Detector' },
  dasconcrete: { pattern: /DLAA[A-Z]{3}\d{6}/, name: 'DasConcrete' },
  das_ai_box: { pattern: /IWAA[A-Z]{3}\d{6}/, name: 'AI Server' },
  das_collision_tag: { pattern: /^TUCA[A-Z]{3}\d{6}/, name: 'DasCTag' },
  dassenses: { pattern: /^S[A-Z]{6}\d{6}$/, name: 'DasSenseH' },
  daswbgt: { pattern: /^W[A-Z]B[A-Z]{4}\d{6}$/, name: 'DasWBGT' },
  dasrp: { pattern: /R(N|M|F|L|W|H)BA[A-Z]{3}\d{6}/, name: 'DasRP' },
};

class ValidatorDasId {
  static validateDasId(
    value: string,
    deviceType: DasEndpointType | LocatorType,
  ): ErrorState {
    if (value === '') {
      return { isError: true, message: 'dasId should not empty.' };
    }
    if (value.length !== 13) {
      return { isError: true, message: 'dasId is 13 digits.' };
    }
    if (!isValidFormat(value)) return FORMAT_ERROR;

    const entry = DAS_ID_PATTERNS[deviceType as DasEndpointType];
    if (entry && !entry.pattern.test(value)) {
      return {
        isError: true,
        message: `Das ID "${value}" not match ${entry.name} naming rule`,
      };
    }

    return { isError: false, message: '' };
  }
}

export default ValidatorDasId;
